"use strict";
/** family: Tabs **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var CLASS_NAME = 'i-tab';
var Tab = React.forwardRef(function (_a, ref) {
    var active = _a.active, children = _a.children, className = _a.className, disabled = _a.disabled, fadeIn = _a.fadeIn, title = _a.title, titleId = _a.titleId, titleAriaLabelledBy = _a.titleAriaLabelledBy, restProps = __rest(_a, ["active", "children", "className", "disabled", "fadeIn", "title", "titleId", "titleAriaLabelledBy"]);
    return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, className, 'tab-pane', {
            active: active,
            disabled: disabled,
            fade: fadeIn,
            show: active,
        }) }, restProps),
        React.createElement("span", { className: "sr-only", tabIndex: -1, role: "tabpanel", id: titleId, "aria-labelledby": titleAriaLabelledBy, ref: ref }, title),
        children));
});
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map